import Vue from "vue";
import VueRouter from "vue-router";
import { isLoggedIn } from "../utils/auth";
import {
  getWechatOauthAttempt,
  isWechatBrowser,
  isWechatOauthPublicRoute,
  startWechatOauth,
} from "../utils/wechatOauth";

Vue.use(VueRouter);

const Home = () => import("../views/Home/Home.vue");
const Workspace = () => import("../views/Workspace/Workspace.vue");
const Dashboard = () => import("../views/Workspace/Dashboard.vue");
const OrderCenter = () => import("../views/OrderCenter/OrderCenter.vue");
const DuplicateCheck = () =>
  import("../views/DuplicateCheck/DuplicateCheck.vue");
const AigcDetection = () => import("../views/AigcDetection/AigcDetection.vue");
const Rewrite = () => import("../views/Rewrite/Rewrite.vue");
const Writing = () => import("../views/Writing/Writing.vue");
const Translation = () => import("../views/Translation/Translation.vue");
const PdfToWord = () => import("../views/PdfToWord/PdfToWord.vue");
const IdPhoto = () => import("../views/IdPhoto/IdPhoto.vue");
const Ppt = () => import("../views/Ppt/Ppt.vue");
const Resume = () => import("../views/Resume/Resume.vue");
const Recharge = () => import("../views/Recharge/Recharge.vue");
const Redeem = () => import("../views/Redeem/Redeem.vue");
const PromotionBenefits = () =>
  import("../views/PromotionBenefits/PromotionBenefits.vue");
const Faq = () => import("../views/Faq/Faq.vue");
const Profile = () => import("../views/Profile/Profile.vue");
const ProfileEdit = () => import("../views/ProfileEdit/ProfileEdit.vue");
const Legal = () => import("../views/Legal/Legal.vue");
const WechatAuth = () => import("../views/WechatAuth/WechatAuth.vue");

const router = new VueRouter({
  mode: "hash",
  routes: [
    { path: "/", name: "home", component: Home },
    {
      path: "/terms",
      name: "terms",
      component: Legal,
      meta: { title: "用户服务协议" },
    },
    {
      path: "/privacy",
      name: "privacy",
      component: Legal,
      meta: { title: "隐私政策" },
    },
    {
      path: "/wechat-auth",
      name: "wechat-auth",
      component: WechatAuth,
      meta: { title: "微信快捷登录" },
    },
    {
      path: "/workspace",
      component: Workspace,
      redirect: "/workspace/dashboard",
      children: [
        {
          path: "dashboard",
          name: "dashboard",
          component: Dashboard,
          meta: { title: "工作台" },
        },
        {
          path: "orders",
          name: "orders",
          component: OrderCenter,
          meta: { title: "订单中心" },
        },
        {
          path: "duplicate-check",
          name: "duplicate-check",
          component: DuplicateCheck,
          meta: { title: "查重检测" },
        },
        {
          path: "aigc-detection",
          name: "aigc-detection",
          component: AigcDetection,
          meta: { title: "免费AIGC检测" },
        },
        {
          path: "rewrite",
          name: "rewrite",
          component: Rewrite,
          meta: { title: "降重/降AI" },
        },
        {
          path: "writing",
          name: "writing",
          component: Writing,
          meta: { title: "智能写作" },
        },
        {
          path: "translation",
          name: "translation",
          component: Translation,
          meta: { title: "论文翻译" },
        },
        {
          path: "pdf-word",
          name: "pdf-word",
          component: PdfToWord,
          meta: { title: "PDF转Word" },
        },
        {
          path: "id-photo",
          name: "id-photo",
          component: IdPhoto,
          meta: { title: "证件照生成" },
        },
        {
          path: "ppt",
          name: "ppt",
          component: Ppt,
          meta: { title: "智能PPT" },
        },
        {
          path: "resume",
          name: "resume",
          component: Resume,
          meta: { title: "智能简历" },
        },
        {
          path: "recharge",
          name: "recharge",
          component: Recharge,
          meta: { title: "账户充值" },
        },
        {
          path: "redeem",
          name: "redeem",
          component: Redeem,
          meta: { title: "兑换码" },
        },
        {
          path: "promotion-benefits",
          name: "promotion-benefits",
          component: PromotionBenefits,
          meta: { title: "推广福利" },
        },
        {
          path: "faq",
          name: "faq",
          component: Faq,
          meta: { title: "常见问题" },
        },
        {
          path: "profile/edit",
          name: "profile-edit",
          component: ProfileEdit,
          meta: { title: "个人中心" },
        },
        {
          path: "profile",
          name: "profile",
          component: Profile,
          meta: { title: "我的" },
        },
      ],
    },
    { path: "*", redirect: "/" },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (!isWechatBrowser() || isLoggedIn() || isWechatOauthPublicRoute(to.path)) {
    next();
    return;
  }
  const attempt = getWechatOauthAttempt();
  if (attempt) {
    next({
      path: "/wechat-auth",
      query: { error: "login_required", target: to.fullPath },
      replace: true,
    });
    return;
  }
  startWechatOauth(to.fullPath);
});

router.afterEach((to) => {
  document.title =
    to.path === "/"
      ? "Paper智创 | 每日免费AIGC检测 - 论文查重、降重与写作工具"
      : `${to.meta.title || "首页"} - Paper 智创`;
});

export default router;
